import settings from './settings.middleware';
import themes from './themes.middleware';

export default [settings, themes];
